import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22_app.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../public/font/Geogrotesque-Regular.otf%22,%22weight%22:%22400%22},{%22path%22:%22../public/font/Geogrotesque-RegularIt.otf%22,%22weight%22:%22400%22,%22style%22:%22italic%22},{%22path%22:%22../public/font/Geogrotesque-Bold.otf%22,%22weight%22:%22600%22},{%22path%22:%22../public/font/Geogrotesque-BoldIt.otf%22,%22weight%22:%22600%22,%22style%22:%22italic%22},{%22path%22:%22../public/font/Geogrotesque-SemiBold.otf%22,%22weight%22:%22600%22},{%22path%22:%22../public/font/Geogrotesque-SemiBoldIt.otf%22,%22weight%22:%22600%22,%22style%22:%22italic%22}],%22display%22:%22swap%22}],%22variableName%22:%22Geogrotesque%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Geogrotesque', 'Geogrotesque Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
